import {
  Menu,
  SidebarContent,
} from "react-pro-sidebar";
import { SlLayers } from "react-icons/sl";
import { BiFolderOpen } from "react-icons/bi";
import { MdSensors } from "react-icons/md";
import { useNavigate } from "react-router-dom"
import "react-pro-sidebar/dist/css/styles.css";
import { type MenuProps } from 'antd';
import { StyledProSidebar, StyledMenu } from './styles'
import { useState } from "react";
import { useTranslation } from 'react-i18next';

export const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [currentPath, setCurrentPath] = useState(location.pathname.split('/')?.[1] || '');

  const handleMenuClick: MenuProps['onClick'] = (e) => {                              
    setCurrentPath(e.key);
    navigate(`/${e.key}`);
  };

  const menuItems: MenuProps['items'] = [                                                                     
    { key: 'test', icon: <BiFolderOpen />, label: t('header.menu.testResult') },
    { key: 'sensor', icon: <MdSensors />, label: t('header.menu.sensorTestResult') },
    { key: 'pad', icon: <SlLayers />, label: t('header.menu.padList') },
  ];
  
  return (
    <StyledProSidebar>
      <SidebarContent>
        <Menu iconShape="square">
          <StyledMenu
              selectedKeys={[currentPath]}
              mode="inline"
              items={menuItems}
              onClick={handleMenuClick}
            />
        </Menu>
      </SidebarContent>
    </StyledProSidebar>
  );
};

export default Header;